import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "content",
  ref: "registerButton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "registerButton noselect",
    to: "register"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "doorLeaf top" }, null, -1),
        _createElementVNode("div", { class: "doorLeaf bottom" }, null, -1),
        _createElementVNode("div", { class: "background absolute-fill" }, [
          _createElementVNode("div", { class: "label" }, "Регистрация")
        ], -1)
      ]), 512)
    ]),
    _: 1
  }))
}